import { getWindowOrThrow } from "../../globals/getWindow";

export const isElementPartiallyInViewport = (
  el: HTMLElement,
  windowHeight: number,
  windowWidth: number
) => {
  const computedStyle: CSSStyleDeclaration =
    getWindowOrThrow().getComputedStyle(el);
  const isHiddenDueToOpacity =
    computedStyle.getPropertyValue("opacity") === "0";
  const isHiddenDueToDisplay =
    computedStyle.getPropertyValue("display") === "none";
  const isHiddenDueToVisibility =
    computedStyle.getPropertyValue("visibility") === "hidden";
  if (
    el.hidden ||
    isHiddenDueToOpacity ||
    isHiddenDueToDisplay ||
    isHiddenDueToVisibility
  ) {
    return false;
  }

  const rect = el.getBoundingClientRect();
  return (
    rect.top !== rect.bottom &&
    rect.left !== rect.right &&
    rect.bottom > 0 &&
    rect.right > 0 &&
    rect.top < windowHeight &&
    rect.left < windowWidth &&
    !isCompletelyHiddenDueToOverflow(el, rect)
  );
};

const isCompletelyHiddenDueToOverflow = (el: HTMLElement, rect: DOMRect) => {
  const elPositioning = getPositioning(rect);
  let parentElement = el.parentElement;
  while (parentElement !== null) {
    const isParentOverflowHidden =
      getWindowOrThrow()
        .getComputedStyle(parentElement)
        .getPropertyValue("overflow") === "hidden";
    if (
      parentElement.nodeType !== Node.DOCUMENT_NODE &&
      isParentOverflowHidden
    ) {
      const parentElPositioning = getPositioning(
        parentElement.getBoundingClientRect()
      );

      const isElRightOfParent = elPositioning.startX > parentElPositioning.endX;
      const isElLeftOfParent = elPositioning.endX < parentElPositioning.startX;
      const isElBelowParent = elPositioning.startY > parentElPositioning.endY;
      const isElAboveParent = elPositioning.endY < parentElPositioning.startY;

      if (
        isElRightOfParent ||
        isElLeftOfParent ||
        isElBelowParent ||
        isElAboveParent
      ) {
        return true;
      }
    }
    parentElement = parentElement.parentElement;
  }

  return false;
};

const getPositioning = (param: {
  x: number;
  width: number;
  y: number;
  height: number;
}) => ({
  startX: param.x,
  endX: param.x + param.width,
  startY: param.y,
  endY: param.y + param.height,
});
